import { ColumnTable, Icon } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../../../locales/translations';

interface actionsColumns {
  onClickDownload: (row: any) => void;
  onClickEdit: (row: any) => void;
  onClickRemove: (row: any) => void;
}

export default function useColumnActions({
  onClickDownload,
  onClickEdit,
  onClickRemove,
}: actionsColumns): ColumnTable[] {
  const { t } = useTranslation(
    TranslationsKeys.TEACHER_MANAGMENT_TEACHER_FILE_ADDITIONAL_DOCUMENTATION,
  );

  return [
    {
      columnName: 'Acciones',
      headerText: t('table.actions'),
      tdClassName: 'text-center',
      thClassName: 'text-center',
      width: 180,
      cellFormat: ({ row }) => {
        return (
          <div className="d-flex justify-content-center">
            {row?.file && (
              <button className="btn" onClick={() => onClickDownload(row)}>
                <Icon color="primary" name="download" />
              </button>
            )}

            <button className="btn" onClick={() => onClickEdit(row)}>
              <Icon color="primary" name="edit" />
            </button>

            <button className="btn" onClick={() => onClickRemove(row)}>
              <Icon name="trash" color="primary" />
            </button>
          </div>
        );
      },
    },
  ];
}
